// extracted by mini-css-extract-plugin
export var container = "_5y-1";
export var cornerButtonContainer = "_5y-6";
export var disabled = "_5y-2";
export var dragActive = "_5y-3";
export var fileContainer = "_5y-5";
export var hiddenInput = "_5y-4";
export var widthContainer = "_5y-0";